import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as postActions from '../../../store/action/post'
import * as fileActions from '../../../store/action/file'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import Uploader from '../../util/uploader';
import ScreenSize from '../../../services/screenSize';
import CkService from "src/services/CkService";
import slug from '@sindresorhus/slugify';
import { remove_non_ascii, getYear, getMonth, getDate } from '../../../utils/common';
import { convertChannelIdToName } from '../../../utils/convert-channel';
import BootstrapSwitchButton from "bootstrap-switch-button-react";

function containsImgTagWithRegex(htmlString) {
  // Regular expression to match <img> tags
  const imgTagPattern = /<img\s+[^>]*src=["'][^"']*["'][^>]*>/i;

  // Test the HTML string against the regex pattern
  return imgTagPattern.test(htmlString);
}
function getImageSrcList(htmlString) {
  // Regular expression to match all <img> tags and capture the src attributes
  const imgSrcPattern = /<img\s+[^>]*src=["']([^"']+)["'][^>]*>/gi;

  // Create an array to store all src values
  const srcList = [];
  
  let match;
  while ((match = imgSrcPattern.exec(htmlString)) !== null) {
    // match[1] contains the value of the src attribute
    srcList.push(match[1]);
  }

  return srcList;
}
class ThumbnailTab extends Component {
  isMobile = false;
  constructor(props) {
    super(props);

    this.state = {
      currentPost: null,
      editor_type: null,
      initThumbHor: null,
      initThumbVer: null,
      indexSuggestThumbHor: 0,
      indexSuggestThumbVer: 0,
      imageUrl: true,
      styleThumb: 'ver',
      selectedFile: {
        name: ''
      },
      src: null,
      crop_ver: {
        unit: 'px',
        width: 414,
        aspect: 10 / 16,
        x: 0,
        y: 0,
      },
      crop_hor: {
        unit: 'px',
        width: 1200,
        minWidth: 1200,
        aspect: 16 / 10,
        x: 0,
        y: 0,
      },
      file: {
        ver: {},
        hor: {}
      },
      img_designed: false
  
    }
    this.isMobile = ScreenSize.isMobile;
  }
  UNSAFE_componentWillMount() {
    const { content, editor_type } = this.props
    this.setState({ currentPost: content, editor_type });
    this.setState({ img_designed: content.img_designed ? content.img_designed : false });
    
    if(editor_type === 'podcast'){
      this.setState({
        crop_ver: {
          aspect: 1,
        },
        crop_hor: {
          aspect: 16 / 9,
        }
      })
    }
    if(editor_type === 'video' || editor_type === 'short'){
      this.setState({
        crop_ver: {
          aspect: 9 / 16,
        },
        crop_hor: {
          aspect: 16 / 9,
        }
      })
    }
    
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { fields, post, typepage, currenttab: currentTab, editor_type: currentEditorType } = this.props;
    const {
      post: nextPost,
      fields: nextFields,
      currenttab: nextTab,
      editor_type: nextEditorType,
    } = nextProps;
    const cropPodcast = {
      crop_ver: {
        aspect: 1,
      },
      crop_hor: {
        aspect: 16 / 9,
      }
    }
    const cropVideo = {
      crop_ver: {
        aspect: 9 / 16,
      },
      crop_hor: {
        aspect: 16 / 9,
      }
    }
    const cropNormal = {
      crop_ver: {
        aspect: 10 / 16,
      },
      crop_hor: {
        aspect: 16 / 10,
      }
    }
    switch(nextEditorType){
      case 'podcast':
        if(this.state.crop_ver.aspect != cropPodcast.crop_ver.aspect || this.state.crop_hor.aspect != cropPodcast.crop_hor.aspect){
          this.setState({
            crop_ver: {
              aspect: 1,
            },
            crop_hor: {
              aspect: 16 / 9,
            }
          })
          console.log("crop thumb podcast");
        }
        break;
      case 'video':
        if(this.state.crop_ver.aspect != cropVideo.crop_ver.aspect || this.state.crop_hor.aspect != cropVideo.crop_hor.aspect){
          this.setState({
            crop_ver: {
              aspect: 9 / 16,
            },
            crop_hor: {
              aspect: 16 / 9,
            }
          })
          console.log("crop thumb 16x9");
        }
        break;
      case 'short':
        if(this.state.crop_ver.aspect != cropVideo.crop_ver.aspect || this.state.crop_hor.aspect != cropVideo.crop_hor.aspect){
          this.setState({
            crop_ver: {
              aspect: 9 / 16,
            },
            crop_hor: {
              aspect: 16 / 9,
            }
          })
          console.log("crop thumb 16x9");
        }
        break;
      default:
        if(this.state.crop_ver.aspect != cropNormal.crop_ver.aspect || this.state.crop_hor.aspect != cropNormal.crop_hor.aspect){
          this.setState({
            crop_ver: {
              aspect: 10 / 16,
            },
            crop_hor: {
              aspect: 16 / 10,
            }
          })
          console.log("crop thumb 16x10");
        }
    }
  }

  noneedcrop = data => {
    const { post: { currentPost } } = this.props
    let type = data.type;

    if(type == 'vertical'){
      currentPost.img_ver = data.url;
    }else{
      currentPost.img_hor = data.url;
    }

    this.props.setCurrentPost(currentPost);
    toast.success("Đã chọn ảnh thumbnail");
  }

  handleImageCrop = data => {
    const { post: { currentPost }, checkRequireData } = this.props

    const tmp_id = currentPost.tmp_id || currentPost.id;
    const fy = getYear(currentPost.createdAt);
    const fm = getMonth(currentPost.createdAt);
    const fddate = getDate(currentPost.createdAt);
    const editor_type = currentPost.editor_type || 'normal';
    let type = data.type;
    
    const blobUrl = data.blob;
    const rawBlob = data.rawBlob;
    if(blobUrl == ""){
      if(type == 'vertical'){
        currentPost.img_ver = "";
      }else{
        currentPost.img_hor = "";
      }
      this.props.setCurrentPost(currentPost);
    }else{
      const doUpload = (sourceBlob) => {
        const fd = new FormData();
        let dataFileNm = data.filename.toLowerCase();
        let fileType = dataFileNm.split('.').pop();
        let fileName = slug(dataFileNm.replace(`.${fileType}`, ''));
        dataFileNm = fileName + '.' + fileType;
        dataFileNm = remove_non_ascii(dataFileNm);
        const file = new File([sourceBlob], dataFileNm, { type: sourceBlob.type || 'image/jpeg' });
        fd.append('upload', file);

        CkService.upload(`/s3/core/connector/php/connector.php?command=FileUpload&lang=vi&type=Images&currentFolder=%2F&hash=e6f15ae802bbf5fe&responseType=json&type=Images&responseType=json&id=${tmp_id}&editorType=${editor_type}&fy=${fy}&fm=${fm}&fd=${fddate}&channel=${convertChannelIdToName(currentPost.channel, this.props.channels)}`,
        fd
        ).then(result => {
          let fileResult = result.data;
          let nameImg = encodeURI(fileResult.currentFolder.url + fileResult.fileName);
          if(type == 'vertical'){
            currentPost.img_ver = nameImg;
          }else{
            currentPost.img_hor = nameImg;
          }
          this.props.setCurrentPost(currentPost);
          checkRequireData(currentPost, 4);
          toast.success("Upload successfully");
        }).catch(error => {
          console.log(error);
          toast.error("Upload failed");
        });
      };

      if (rawBlob) {
        doUpload(rawBlob);
      } else {
        fetch(blobUrl).then(res => res.blob()).then(fetchedBlob => {
          doUpload(fetchedBlob);
        }).catch(error => {
          console.log(error);
          toast.error("Upload failed");
        });
      }
    }
  }
  suggestThumb = (type) => {
    console.log("suggestThumb");
    const images = getImageSrcList(this.state.currentPost.content);
    const indexSuggestThumbHor = this.state.indexSuggestThumbHor;
    const indexSuggestThumbVer = this.state.indexSuggestThumbVer;
    console.log(images);
    if(images){
      if(type == "hor"){
        this.setState({
          initThumbHor: images[indexSuggestThumbHor],
          indexSuggestThumbHor: indexSuggestThumbHor + 1 >= images.length ? 0 : indexSuggestThumbHor + 1
        })
      }
      if(type == "ver"){
        this.setState({
          initThumbVer: images[indexSuggestThumbVer],
          indexSuggestThumbVer: indexSuggestThumbVer + 1 >= images.length ? 0 : indexSuggestThumbHor + 1
        })
      }
    }
  }
  handleChangeImgDesigned = (check) => {
    this.setState({
      img_designed: check
    });
    const { post: { currentPost } } = this.props;
    currentPost.img_designed = check;
    this.props.setCurrentPost(currentPost);
  }

  render() {
    const { currentPost, crop, croppedImageUrl, src, editor_type, initThumbHor } = this.state;
    const { layoutName, checkClass, channels } = this.props;

    return (

      <div className={(layoutName !== 'layout-pc' ? 'row card' : '')}>
        {
          layoutName !== 'layout-pc' &&
          <div className={"card-header col-12 " + (checkClass)}>
            <h4 className="card-title">Thumbnail</h4>
            <div className="card-tools">
              <button type="button" className="btn btn-tool" data-card-widget="collapse">
                <i className="fas fa-minus"></i>
              </button>
            </div>
          </div>

        }

        <div className="card-body col-12">
          <div className="row">
            <div className="d-flex col-12 align-items-center mb-4 justify-content-between">
              <span className="mr-2 fz-15" style={{color: '#212529'}}>Ảnh được thiết kế</span>
              <div className="icheck-success d-inline ml-2">
                <input
                  id={`image_designed`}
                  type="checkbox"
                  name="image_designed"
                  checked={this.state.img_designed}
                  onChange={(event) => {
                    this.handleChangeImgDesigned(event.target.checked);
                  }}
                />
                <label htmlFor={`image_designed`}></label>
              </div>
              
          </div>
          
            {(layoutName === 'layout-pc') &&
              <ul className="nav nav-tabs" id="custom-content-below-tab" role="tablist">
                <li className="nav-item active">
                  <a className="nav-link" id="custom-content-below-profile-tab" data-toggle="pill"
                    href="#custom-content-below-profile" role="tab" aria-controls="custom-content-below-profile" aria-selected="false">Thumbnail Ngang</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" id="custom-content-below-home-tab" data-toggle="pill"
                    href="#custom-content-below-home" role="tab" aria-controls="custom-content-below-home" aria-selected="true">Thumbnail Dọc</a>
                </li>

              </ul>
            }
            <div className="tab-content col-12 thumbnail" id="custom-content-below-tabContent">
              {(layoutName !== 'layout-pc') && <label>Thumbnail Ngang</label>}
              {currentPost && containsImgTagWithRegex(currentPost.content) && !currentPost.img_hor &&
                <button type="button" className="ml-2 btn btn-primary" onClick={(e) => this.suggestThumb("hor")}>Lấy ảnh trong bài</button>
              }
              <div style={{ width: layoutName === 'layout-pc' ? "50%" : "100%", margin: "0 auto" }} className="tab-pane fade show active" id="custom-content-below-profile" role="tabpanel" aria-labelledby="custom-content-below-profile-tab">
                {currentPost && <Uploader initSrcCrop={initThumbHor} channels={channels} channel={currentPost.channel} editor_type={this.state.editor_type} dragagain={true} tmp_id={currentPost.tmp_id || currentPost.id} url={currentPost.img_hor} crop={this.state.crop_hor} type="horizontal" noneedcrop={this.noneedcrop} handleImageCrop={this.handleImageCrop} post={currentPost}/>}
              </div>
              {(layoutName !== 'layout-pc') && <label style={{ marginTop: "20px" }}>Thumbnail Dọc</label>}
              {currentPost && containsImgTagWithRegex(currentPost.content) && !currentPost.img_ver &&
                <button type="button" className="ml-2 btn btn-primary" onClick={(e) => this.suggestThumb("ver")}>Lấy ảnh trong bài</button>
              }
              <div style={{ width: layoutName === 'layout-pc' ? "30%" : "100%", }} className={"tab-pane fade" + (layoutName === 'layout-pc' ? '' : ' show active')} id="custom-content-below-home" role="tabpanel" aria-labelledby="custom-content-below-home-tab">
                {currentPost && <Uploader initSrcCrop={this.state.initThumbVer} channels={channels} channel={currentPost.channel} editor_type={this.state.editor_type} dragagain={true} tmp_id={currentPost.tmp_id || currentPost.id} url={currentPost.img_ver} crop={this.state.crop_ver} type="vertical" noneedcrop={this.noneedcrop} handleImageCrop={this.handleImageCrop} post={currentPost}/>}
              </div>

            </div>


          </div>
        </div>

      </div>
    );


  }

};




export default connect(store => {
  return {
    post: store.post,
    fileUpload: store.fileUpload
  };
}, dispatch => {
  return {
    setCurrentPost: (value) => { dispatch(postActions.setCurrentPost(value)) },
    uploadFile: (value) => { dispatch(fileActions.uploadFile(value)) },
  }
})(ThumbnailTab)
